import { Directive, InjectionToken, TemplateRef } from '@angular/core';

export const SELECT_ITEM_CONTENT =
  new InjectionToken<SelectItemContentDirective>('SelectItemContent');

@Directive({
  selector: '[appItem]',
  providers: [
    { provide: SELECT_ITEM_CONTENT, useExisting: SelectItemContentDirective },
  ],
  standalone: false,
})
export class SelectItemContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
